import { cn } from "../utils/classnames";

const StepperProgressBar = ({
  currentStep,
  totalSteps,
  durationMs,
  className,
  ariaLabel,
}: {
  currentStep: number;
  totalSteps: number;
  durationMs: number;
  className?: string;
  ariaLabel?: string;
}) => {
  const resolvedDuration = Math.max(0, durationMs) / 1000;

  return (
    <div
      aria-label={ariaLabel}
      aria-valuemax={totalSteps}
      aria-valuemin={0}
      aria-valuenow={currentStep}
      className={cn("w-full", className)}
      role="progressbar"
    >
      <div className="relative mx-auto h-2 w-full max-w-[368px] rounded-[8px] bg-gray">
        <div
          aria-hidden="true"
          className="absolute top-0 left-0 h-full animate-progress-fill rounded-l-[4px] bg-success"
          style={{ animationDuration: `${resolvedDuration}s` }}
        />
      </div>
    </div>
  );
};

export default StepperProgressBar;
